import bffRequest from '../../../shared/requests/bffRequest';
import type { ElitePlusCarouselListingResponse } from './elitePlusCarouselListingResponse';

export const getNews = async (featureFlags?: string[]) => {
  const response = await bffRequest({
    path: 'news',
    method: 'GET',
    query: {
      featureFlags,
    },
  });

  return { articles: response };
};

export const getElitePlusCarouselListings = async (
  userId?: string,
): Promise<ElitePlusCarouselListingResponse> => {
  const response = await bffRequest({
    path: `eliteplus-carousel/${userId}`,
    method: 'GET',
  });

  return response as ElitePlusCarouselListingResponse;
};
